import React, { Component } from "react";
import { connect } from "react-redux";
import { extendSession as extendSession } from "../../../domain/auth/authActions";
import { FormattedMessage } from "react-intl";
import moment from "moment";
import { IDLE_SESSION_WARN_MODAL_DURATION } from "assets/scripts/constants/Constants";
class Timeout extends Component {
    constructor() {
        super(...arguments);
        this.state = {
            seconds: this._getSeconds().seconds
        };
    }
    componentDidMount() {
        this._updateSeconds();
    }
    componentDidUpdate() {
        this._updateSeconds();
    }
    componentWillUnmount() {
        clearTimeout(this._recheckHandle);
    }
    _updateSeconds() {
        clearTimeout(this._recheckHandle);
        const { seconds, recheckMs } = this._getSeconds();
        if (seconds !== this.state.seconds) {
            this.setState({ seconds });
        }
        if (recheckMs != null) {
            this._recheckHandle = setTimeout(() => this._updateSeconds());
        }
    }
    render() {
        const { seconds } = this.state;
        return (<div>
				<div className="vr vr_x5">
					<h1 className="hdg">
						<FormattedMessage id="timeout.header" defaultMessage="Your session is timing out"/>
					</h1>
				</div>
				{seconds != null && (<div className="vr vr_x5">
						<div className="text">
							<FormattedMessage tagName="p" id="timeout.message" defaultMessage="You'll be logged out in {seconds} seconds." values={{
            seconds
        }}/>
						</div>
					</div>)}
				<div className="vr vr_x5">
					<button type="button" className="btn js-modal-btnTrigger btn-action" data-modaltriggerid="validateAddAccount" onClick={this.props.onExtendSession}>
						<FormattedMessage id="timeout.button" defaultMessage="Stay logged in"/>
					</button>
				</div>
			</div>);
    }
    _getSeconds() {
        const { sessionWarnTimestamp } = this.props;
        if (sessionWarnTimestamp == null) {
            return {
                seconds: null,
                recheckMs: null
            };
        }
        const now = moment();
        const expiresAt = moment(sessionWarnTimestamp)
            .add(IDLE_SESSION_WARN_MODAL_DURATION, "seconds");
        const diff = expiresAt.diff(now);
        if (diff <= 0) {
            return {
                seconds: 0,
                recheckMs: null
            };
        }
        return {
            seconds: Math.round(diff / 1000),
            recheckMs: diff - (1000 * Math.floor(diff / 1000))
        };
    }
}
export default connect((state) => ({
    sessionWarnTimestamp: state.auth.sessionWarnTimestamp
}), {
    onExtendSession: extendSession
})(Timeout);



// WEBPACK FOOTER //
// ./src/assets/scripts/components/containers/modals/Timeout.tsx